import React, { MouseEvent, useRef, useState } from "react";
import styles from './multiple-select.css';
import InlineSvg from 'Shared/components/inline-svg';
import Animation from 'Shared/components/animation';
import { useOnClickOutside } from "Shared/util/custom-hooks";
import { joinClassNames as c } from "Shared/util/styles";
import Tooltip from "./tooltip";

export type MultiSelectItem = {
    disabled?: boolean;    
    key: string;
    label: string;
}

type MultipleSelectProps = {
    items: MultiSelectItem[];
    disabled?: boolean;
    label: string;
    onChange: (key: MultiSelectItem["key"]) => void;
    selectedItems: MultiSelectItem["key"][];
}

export const MultipleSelect = ({items, label, disabled, selectedItems, onChange}: MultipleSelectProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const handleOpenChange = () =>
        setIsOpen(!isOpen);

    useOnClickOutside(ref, () => isOpen && handleOpenChange());

    const handleItemClicked = (event?: MouseEvent<HTMLButtonElement>) => {
        const itemKey = event?.currentTarget?.value;
        
        if(itemKey){
            onChange(itemKey);
        }
    }

    return(
        <Tooltip
            placement={
                "bottom-start"
            }
            tooltip={label}
            trigger={selectedItems.length > 2 ? "hover" : null}
        >
            <div ref={ref} className={`${styles.multiSelectContainer}`}>
                <div className={styles.selectContainer}>
                    <button
                        type="button"
                        onClick={!disabled ? handleOpenChange : undefined}
                        className={disabled ? styles.disabled : ''}
                    >
                    <span className={styles.placeholderText}>{label}</span>
                    </button>
                    <div className={styles.hiddenMaxWidth}>
                        <button type="button">
                            {label}
                        </button>
                    </div>
                    <InlineSvg src="/caret-down.svg" 
                        className={c(
                            styles.svgContainer,
                            isOpen ? styles.caretUp : styles.caretDown

                        )}/>
                </div>
                <Animation
                    show={isOpen}
                    animation="slide_down"
                >
                    <div className={styles.list}>
                    <ul>
                        {items.map(({key, label, disabled}) => (
                        <li
                            key={key}
                            className={c(
                                disabled && styles.disabled,
                                selectedItems.includes(key) && styles.selected

                            )}
                        >
                            <button
                                disabled={disabled}
                                onClick={handleItemClicked}
                                type="button"
                                value={key}
                            >
                            {label}
                            </button>
                        </li>
                        ))}
                    </ul>
                    </div>
                </Animation>                         
            </div>
        </Tooltip>
    )
}